import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SettingsMenuOverview() {
  const { t } = useTranslation();
  const p = 'documentation.settingsMenu';

  return (
    <div className="doc-settings-menu mb-4">
      <p className="mb-2">{t(`${p}.intro`)}</p>
      <ul className="doc-settings-menu-list list-unstyled mb-0">
        <li>
          <strong>{t(`${p}.generalSettings`)}</strong>
          <ul>
            <li>{t(`${p}.profile`)}</li>
            <li>{t(`${p}.security`)}</li>
            <li>{t(`${p}.notifications`)}</li>
          </ul>
        </li>
        <li>
          <strong>{t(`${p}.userManagement`)}</strong>
          <ul>
            <li>{t(`${p}.users`)}</li>
            <li>{t(`${p}.roles`)}</li>
            <li>{t(`${p}.teams`)}</li>
          </ul>
        </li>
        <li>
          <strong>{t(`${p}.organizationDetails`)}</strong>
          <ul>
            <li>{t(`${p}.privacyPolicy`)}</li>
            <li>{t(`${p}.termsOfUse`)}</li>
            <li>{t(`${p}.cookiePolicy`)}</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
